<template>
    <div v-if="show && loaded" class="nevs-popup-container">
        <div class="nevs-popup">
            <div class="popup-form">
                <div class="e-invoices-disclaimer" v-html="$LANG.Get('texts.eInvoicesDisclaimer')"></div>
                <div v-if="showCopyAlert" class="e-invoices-alert" v-html="$LANG.Get('texts.eInvoicesCopyAlert')"></div>
                <NevsSelect :error="validation.type" :label="$LANG.Get('fields.invoiceType') + ':'" v-model="data.type" :ajax="'select/e-invoice-types'" :nullable="true"></NevsSelect>
                <NevsSelect :error="validation.profile" :label="$LANG.Get('fields.businessProcess') + ':'"  v-model="data.profile" :ajax="'select/e-invoice-profiles'" :nullable="true"></NevsSelect>
                <div class="tax-category-validation" v-if="validation.tax_categories != ''">{{ validation.tax_categories }}</div>
                <div class="tax-category" v-for = "(taxCategory, key) in data.tax_categories" :key="key">
                    <NevsSelect :nullable="true" :label="$LANG.Get('fields.taxCategory') + taxCategory.tax_rate + '% :'"  v-model="taxCategory.tax_category_id" :ajax="'select/tax-categories'"></NevsSelect>
                    <NevsTextArea v-if="taxCategory.tax_category_id == 7 || taxCategory.tax_category_id == 8" :label="$LANG.Get('fields.taxExemptionNote') + taxCategory.tax_rate + '% :'"  v-model="taxCategory.tax_exemption_note"></NevsTextArea>
                </div>
                <NevsTextField :label="$LANG.Get('fields.orderForm') + ':'"  v-model="data.order_form"></NevsTextField>
                <NevsTextField :label="$LANG.Get('fields.contract') + ':'"  v-model="data.contract"></NevsTextField>
                <NevsSelect v-if="businessUnits.length > 0" :label="$LANG.Get('fields.businessUnit') + ':'"  v-model="data.business_unit" :options="businessUnits" :nullable="true"></NevsSelect>
            </div>
            <div class="nevs-popup-buttons">
                <NevsButton class="error" @click="cancelClick()">
                    <i class="fa-solid fa-xmark"></i>
                    {{ $LANG.Get('buttons.cancel') }}
                </NevsButton>
                <NevsButton class="success" @click="sendClick()">
                    <i class="fa-solid fa-paper-plane"></i>
                    {{ $LANG.Get('buttons.send') }}
                </NevsButton>&nbsp;
            </div>
        </div>
    </div>
</template>

<script>
import NevsButton from "@/components/nevs/NevsButton.vue";
import NevsSelect from "@/components/nevs/NevsSelect.vue";
import NevsTextField from "@/components/nevs/NevsTextField.vue";
import NevsTextArea from "@/components/nevs/NevsTextArea.vue";

export default {
    name: "ModalEInvoice",
    components: {NevsTextArea, NevsTextField, NevsSelect, NevsButton},
    data() {
        return {
            data: {
                profile: null,
                type: null,
                order_form: '',
                contract: '',
                business_unit: null,
                tax_categories: []
            },
            validation: {
                profile: '',
                type: '',
                tax_categories: ''
            },
            invoice: null,
            businessUnits: [],
            loaded: false,
            showCopyAlert: false
        }
    },
    props: {
        show: {
            type: Boolean,
            default: false,
        },
        invoiceId: {
            type: Number,
            default: null,
        }
    },
    emits: ['done'],
    watch: {
        'show'() {
            this.loaded = false;
            this.data = {
                profile: null,
                type: null,
                order_form: '',
                contract: '',
                business_unit: null,
                tax_categories: []
            };
            this.validation = {
                profile: '',
                type: '',
                tax_categories: ''
            };
            this.showCopyAlert = false;
            if (this.show && this.invoiceId != null) {
                let vm = this;
                this.$API.APICall('get', 'invoices/e-invoice-data/' + this.invoiceId, {}, (data, success) => {
                    if (success) {
                        vm.invoice = data.invoice;
                        vm.data.tax_categories = data.tax_categories;
                        if (vm.invoice.xml_data.profile !== undefined) vm.data.profile = vm.invoice.xml_data.profile;
                        if (vm.invoice.xml_data.type !== undefined) vm.data.type = vm.invoice.xml_data.type;
                        if (vm.invoice.xml_data.order_form !== undefined) vm.data.order_form = vm.invoice.xml_data.order_form;
                        if (vm.invoice.xml_data.contract !== undefined) vm.data.contract = vm.invoice.xml_data.contract;
                        if (vm.invoice.xml_data.tax_categories !== undefined) vm.data.tax_categories = vm.invoice.xml_data.tax_categories;
                        if (vm.invoice.e_invoice_id !== null || vm.invoice.e_reporting_id !== null) vm.showCopyAlert = true;
                        vm.businessUnits = data.business_units;
                        vm.$nextTick(() => {
                            vm.loaded = true;
                        })
                    }
                });
            }
        }
    },
    methods: {
        cancelClick() {
            this.$emit('done', false);
        },
        sendClick() {
            let valid = true;

            if (this.data.type === null) {
                valid = false;
                this.validation.type = this.$LANG.Get('labels.mandatoryField');
            } else {
                this.validation.type = '';
            }

            if (this.data.profile === null) {
                valid = false;
                this.validation.profile = this.$LANG.Get('labels.mandatoryField');
            } else {
                this.validation.profile = '';
            }

            for (let taxCategory of this.data.tax_categories) {
                if (taxCategory.tax_category_id === null) {
                    valid = false;
                    this.validation.tax_categories = this.$LANG.Get('labels.taxCategoryNeedsToBeSelected');
                } else {
                    this.validation.tax_categories = '';
                }
            }

            if (valid) {
                let popupText = this.$LANG.Get('alerts.eInvoiceQuestion');
                if (this.invoice.f2_status === 3) popupText = this.$LANG.Get('alerts.eReportingQuestion');
                let vm = this;
                this.$LOCAL_BUS.TriggerEvent('popup', {
                    type: 'confirm', text: popupText, callback: (response) => {
                        if (response) {
                            let endpoint = 'invoices/e-invoice/';
                            if (vm.invoice.f2_status === 3) endpoint = 'invoices/e-reporting/';
                            vm.$API.APICall('post', endpoint + this.invoiceId, this.data, (data, success) => {
                                vm.$CROSS_TAB_BUS.TriggerEvent('reload-invoices', {});
                                if (success) {
                                    if (endpoint === 'invoices/e-reporting/') {
                                        vm.$LOCAL_BUS.TriggerEvent('popup', {
                                            text: vm.$LANG.Get('alerts.eReportingManualSend'),
                                            type: 'alert'
                                        });
                                    } else {
                                        vm.$LOCAL_BUS.TriggerEvent('popup', {
                                            text: vm.$LANG.Get('alerts.eInvoiceSendSuccess'),
                                            type: 'alert'
                                        });
                                    }
                                    this.$emit('done', true);
                                } else {
                                    if (data.message !== undefined) {
                                        vm.$LOCAL_BUS.TriggerEvent('popup', {
                                            text: data.message,
                                            type: 'alert'
                                        });
                                    } else {
                                        vm.$HELPERS.HandleServerError(vm, data);
                                    }
                                }
                            });
                        }
                    }
                });
            }
        }
    }
}
</script>


<style scoped lang="scss">
@use '../../scss/vars' as *;

.popup-form {
    padding: 10px;
}

.e-invoices-disclaimer {
    padding: 5px;
    margin-bottom: 10px;
}

.e-invoices-alert {
    background: $salmon;
    padding: 10px;
    color: $ink-strong;
    margin: 5px;
    margin-bottom: 10px;
}

.tax-category {
    border: 1px solid $sand-300;
}

.tax-category-validation {
    color: $danger;
    border: 1px solid $sand-300;
}

</style>